import type { StripeType } from "../components/StripeInterface";

const POLL_INTERVAL_MS = 3000;
const MAX_WAIT_MS = 60_000;

export const INSUFFICIENT_FUNDS_MESSAGE =
  "This bank account doesn't have enough funds for this payment. Please try a different account.";

const FAILURE_MESSAGES: Record<string, string> = {
  account_closed:
    "This bank account is closed. Please try a different account.",
  debit_not_authorized:
    "Your bank didn't authorize this debit. Please contact your bank or try a different account.",
  insufficient_funds: INSUFFICIENT_FUNDS_MESSAGE,
  no_account:
    "We couldn't find this bank account. Please try a different account.",
};

export function achFailureMessage(
  error?: { code?: string; message?: string } | null,
): string {
  return (
    (error?.code && FAILURE_MESSAGES[error.code]) ||
    error?.message ||
    "Your bank payment failed. Please try a different account."
  );
}

/**
 * ACH debits stay in processing until the bank returns or settles them. Returns are days later in production
 * but within seconds in test mode, so the checkout waits a little before moving on. Resolves with the failure
 * message, or null when the payment is still processing or succeeded.
 */
export async function waitForAchFailure(
  stripe: StripeType,
  clientSecret: string,
): Promise<null | string> {
  const deadline = Date.now() + MAX_WAIT_MS;

  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

    if (paymentIntent?.status === "requires_payment_method") {
      return achFailureMessage(paymentIntent.last_payment_error);
    }
    if (paymentIntent?.status !== "processing") return null;
  }

  return null;
}
